import { gql } from "@apollo/client";

export default gql`
  mutation oneTimesUpdateMutation($type: oneTimesType!, $metaData: Object!){
    oneTimesUpdateMutation(type: $type, metaData: $metaData){
        success
        data
        code
        message
    }
}
`
